import React from 'react';
import ProfileButton from './ProfileButton';
import TabPane from "./TabPane";

const InfrastructureOptions = (props) => {

  return (
    <div>
      <div className="infrastructureOptions">
        <div className="row compareTable vCenter">
          <div className="col-xs-10">
            <h5 className="title6 weightBold">Additional Infrastructure</h5>
          </div>
          <div className="col-xs-2 totalColumn">&nbsp;</div>
        </div>

        <div className="clearfix"></div>      

        <div className="row compareTable">
          <div className="col-xs-10 tabBtn">
            <ProfileButton id= "balanced" buttonName = "Balanced profile" state={props.state}/>
            <ProfileButton id = "heavy" buttonName = "Compute-heavy Profile" state={props.state}/>
            <ProfileButton id= "light" buttonName = "Compute-light Profile" state={props.state}/>
          </div>

          <div className="col-xs-2 totalColumn">
            &nbsp;
          </div>
        </div>

        {props.state.subCategory === 'balanced' && <TabPane data = {props.state} WindowName = "BalancedProfile"/>}
        {props.state.subCategory === 'heavy' && <TabPane data = {props.state} WindowName = "ComputeHeavyProfile"/>}
        {props.state.subCategory === 'light' && <TabPane data = {props.state} WindowName = "ComputeLightProfile"/>}

      </div>
      <div className="clearfix"></div>
    </div>
  );
};

export default InfrastructureOptions;
